import { customElement, property, query } from "lit/decorators.js";
import { SqlEditorAdapter } from "./sqlEditorAdapter";
import { ComponentId, ComponentStore, dom, SplitContainer } from "@omegagrid/core";
import { AppComponent } from "../component";
import { SqlEditor } from "./sqlEditor";
import { SqlParameterList } from "./sqlParameterList";
import { html, css } from "lit";
import { SqlParameterListAdapter } from "./sqlParameterListAdapter";
import rp from "../global";
import { Saveable } from "../types";

@customElement('rp-editor-sql-container')
export class SqlEditorContainer extends AppComponent implements Saveable {

	static styles = css`
		:host {
			display: flex;
			position: relative;
			flex-direction: column;
			height: 100%;
		}

		* {
			box-sizing: border-box;
		}

		og-splitcontainer {
			height: 100%;
		}
	`;

	@property({type: Object})
	editorAdapter: SqlEditorAdapter;

	@property({type: Object})
	parameterListAdapter: SqlParameterListAdapter;

	@query('og-splitcontainer')
	splitContainer: SplitContainer;

	get editor() { return this.componentStore?.items.get(0) as SqlEditor }
	get parameterList() { return this.componentStore?.items.get(1) as SqlParameterList }

	componentStore = new ComponentStore((index: number) => {
		if (index == 0) {
			return dom.createElement<SqlEditor>('rp-editor-sql', {
				app: this.app,
				adapter: this.editorAdapter,
				rightToggle: false,
				listeners: [[
					'toggleRight', () => {
						this.splitContainer.collapse(1, false);
						this.editor.rightToggle = false;
					}
				]]
			});
		} else {
			if (!this.parameterListAdapter) {
				this.splitContainer.collapse(1);
				return null;
			}
			if (rp.host.compact) {
				this.splitContainer.collapse(1);
				this.editor.rightToggle = true;
			}
			return dom.createElement<SqlParameterList>('rp-sql-parameters', {
				app: this.app,
				adapter: this.parameterListAdapter,
				listeners: [
					['collapse', () => {
						this.splitContainer.collapse(1);
						this.editor.rightToggle = true;
					}]
				]
			});
		}
	});

	render = () => html`
		<og-splitcontainer
			orientation="horizontal"
			.createComponent="${(id: ComponentId) => this.componentStore.get(id)}"
			.items="${[{size: null}, {size: 250}]}">
		</og-splitcontainer>
	`;

	layout() {
		this.splitContainer?.layout();
	}

	async save() {
		await this.editor?.save();
	}

}
